/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 菲律宾语 国际化语言文件
 */
// 菲律宾语.js
export default {
  centerAgent: {
    subagency: 'Sub-agency',
    search: 'Maghanap',
    subagencyIncome: 'Kita ng Sub-agency',
    last29Days: 'Nakaraang 29 Araw',
    excludingToday: 'Hindi Kasama ang Ngayon',
    commission: 'Komisyon',
    last30Days: 'Datong Huling 30 Araw',
    rank: 'Ranggo',
    hostNumber: 'Bilang ng Host',
    recent30Days: 'Kita ng Host sa Nakaraang 30 Araw',
    commissionRate: 'Rate ng Komisyon',
    myCommission: 'Aking Komisyon',
    remove: 'Alisin',
    thisAction: 'Ang aksyon na ito ay mag-aalis ng {hostoragent} {hostname} mula sa iyong koponan. Pinatototohanan mo bang magpapatuloy?',
    dashboard: 'Dashboard',
    information: 'Impormasyon',
    dataCenter: 'Data Center',
    hostList: 'Listahan ng Host',
    bdList: 'Listahan ng BD',
    agencyList: 'Listahan ng Agency',
    myRight: 'Aking Karapatan',
    numberOf: 'Bilang ng Agency',
    inviteAgency: 'Mag-imbita ng Agency',
    numberOfHost: 'Bilang ng Host',
    inviteHost: 'Mag-anyaya ng Host',
    inviteHostlinkcopied: 'Nakopya ang link ng imbitasyon.',
    tipsShare: 'Mga Tip: Ibahagi ang link ng imbitasyon sa iyong mga kaibigan',
    thisMonthD: 'Datong Buwan na Ito',
    formDay1: 'Mula day1 hanggang day2',
    hostGift: 'Puntos ng Regalo ng Host',
    agentCommission: 'Komisyon ng Ahente',
    currentLevel: 'Kasalukuyang Antas',
    commissionRateOf: 'Rate ng komisyon ng kita ng mga ahente',
    baseSalary: 'Batayang Sahod',
    stillNeed: 'Kailangan pa',
    toReach: 'upang maabot',
    reachedthe: 'Gawain sa Advertisement',
    advertisementTask: 'Pangkalahatang-ideya ng Data',
    dataOverview: 'Pangkalahatang-ideya ng Data',
    today: 'Ngayon',
    hostPoint: 'Puntos ng Host',
    agentsPoints: 'Kita sa Mga Puntos ng Ahente',
    thisMonth: 'Ngayong Buwan',
    month: 'Buwan',
    lastMonth: 'Nakaraang Buwan',
    bdNumber: 'Bilang ng BD',
    hostIncome: 'Kita ng Host',
    todayIncome: 'Kita Ngayon',
    past30Days: 'Nakaraang 30 Araw',
    host: 'Host',
    country: 'Bansa',
    level7: 'Antas / 7-Araw na Kita',
    pointIncome: 'Kita sa Mga Puntos',
    liveDuration: 'Live na Tagal',
    joinTime: 'Oras ng Pagsali',
    state: 'Katayuan',
    operation: 'Operasyon',
    bd: 'BD',
    totalHosts: 'Kabuuang Kita ng Host',
    totalAgents: 'Kabuuang Kita ng Ahente',
    agent: 'Ahente',
    agentLevel: 'Antas ng Ahente / Rate ng Komisyon',
    commissionIncome: 'Kita sa Komisyon',
    showDirect: 'Ipakita lamang ang mga direktang ahente.Hindi kasama ang datos ngayon',
    excludingTodayData: 'Hindi kasama ang datos ngayon',
    packages: 'Mga Package',
    contents: 'Mga Nilalaman',
    balance: 'Balanse',
    release: 'Pakawalan',
    issue: 'Isyu',
    createBd: 'Gumawa ng BD',
    times: 'beses',
    authorizeCs: 'Pahintulutan ang CS',
    giftTo: 'Iregalo sa User',
    bdCreation: 'Natitirang Limit sa Paggawa ng BD',
    csAuthorization: 'Natitirang Kota ng Awtorisasyon ng CS',
    giftName: 'Pangalan ng Regalo',
    giftContents: 'Nilalaman ng Regalo',
    check: 'Suriin',
    cancel: 'Kanselahin',
    tip: 'Tip',
    recipientsVip: 'Lampas na ang VIP tier ng tumatanggap sa limitasyon ng gift package. Hindi magagamit ang mga benepisyo ng VIP mula sa regalong ito. Siguradong magpapatuloy?',
    confirm: 'Kumpirmahin',
    authorize: 'Pahintulutan',
    inviteBy: 'Imbitahan sa pamamagitan ng User ID',
    invite: 'Imbitahan',
    inviteLink: 'Link ng Imbitasyon',
    copy: 'Kopyahin',
    success: 'Tagumpay',
    pleaseCheck: 'Pakisingnan ang User ID',
    totalGift: 'Kabuuang Kita sa Regalo ng Lahat ng Host (hindi kasama ang mga platform reward tulad ng ranking, task, atbp.), kasama ang kita sa regalo ng mga sub agency.',
    totalAgentsCom: 'Kabuuang komisyon ng mga ahente mula sa kita ng kanilang host, kasama ang komisyon ng mga sub ahente.',
    allAgent: 'Lahat ng Ahente',
    directAgent: 'Direktang Ahente',
    indirectAgent: 'Hindi Direktang Ahente',
    newUpgraded: 'Bagong Na-upgrade na Ahente',
    newS: 'Bagong Agent S',
    newB: 'Bagong Agent B',
    newC: 'Bagong Agent C',
    expectedReward: 'Inaasahang Gantimpala',
    newA: 'Bagong Agent A',
    agencyLevel: 'Antas ng Ahensya',
    nickname: 'Palayaw',
    upgradeDate: 'Petsa ng Pag-upgrade',
    bdPolicy: 'Patakaran sa BD',
    agencyDetail: 'Detalye ng Ahensya',
    agency: 'Ahensya',
    hostCommission: 'Komisyon ng Host',
    last6Days: 'Nakaraang 6 na Araw',
    giftIncome: 'Kita sa Regalo',
    mins: 'min',
    agencyCenter: 'Ahensya Center',
    myIncome: 'Kita Ko Ngayon',
    totalHost: 'Kabuuang Host Points',
    overview: 'Pangkalahatang-ideya',
    hostPoints: 'Host Points',
    myHosts: 'Aking Host Points',
    subagentHost: 'Host Points ng Sub-agent',
    subagencyNumber: 'Bilang ng Sub-agency',
    otherIncome: 'Iba Pang Kita',
    contactAdmin: 'Makipag-ugnayan sa Admin',
    whatsapp: 'WhatsApp',
    bdCenter: 'BD Center',
    copySuccess: 'Kopya Tagumpay',
    pleaseInput: 'Mangyaring ilagay ang halaga ng recharge, minimum na 10',
    agencyPolicy: 'Patakaran sa Ahensya',
    agencyCommission: 'Komisyon ng Ahensya',
    agencyCommission2: 'Komisyon ng Ahensya = Rate ng Komisyon × Kabuuang Kita sa Regalo ng Lahat ng Host (hindi kasama ang mga platform reward tulad ng ranking, task, atbp.)',
    excludingPlatform: '(hindi kasama ang mga platform reward tulad ng ranking, task, atbp.)',
    agencyCommissionCalculation: 'Pagkalkula ng Komisyon ng Ahensya',
    level: 'Antas',
    pointsTarget: 'Target ng Mga Puntos (Nakaraang 30 Araw)',
    points10000: '10,000 Points = 1 USD (M= milyon)',
    note1: 'Tala 1: Kabuuang Balidong Kita = Kita ng iyong ahensya + Kita ng bawat tier ng iyong mga sub-ahensya',
    note2: 'Tala 2: Ang mga komisyon ng ahensya ay ia-kredito nang real-time kapag nakatanggap ng regalo ang host.',
    note3: 'Tala 3: Ang minimum na halaga ng pag-withdraw ay 10 USD, at ang mga pag-withdraw ay dapat nasa multiple ng 10 (halimbawa: 10 USD, 20 USD, 30 USD).',
    subagencycommission: 'Komisyon ng Sub-Ahensya',
    theMain: 'Ang pangunahing ahensya ay maaaring kumita ng mga komisyon mula sa kita ng bawat tier ng mga sub-ahensya (T1, T2, T3, T4, ... Tn), na may pinakamataas na rate ng komisyon na 16%.',
    forExample: 'Halimbawa:',
    agencyA: 'Inanyaya ng Agency A ang Agency B at Agency C.',
    agencyB: 'Inanyaya ng Agency B ang Agency D at Agency E.',
    agencyC: 'Inanyaya ng Agency C ang Agency F.',
    noteFigures: '(Tandaan: ang mga numero sa panaklong ay kumakatawan sa kita ng mga host sa ilalim ng bawat ahensya).',
    thusWe: 'Kaya, maaari nating kalkulahin ang Kabuuang Balidong Kita at Rate ng Komisyon ng mga ahensya mula Agency A hanggang Agency F.',
    totalValid: 'Kabuuang Balidong Kita = Kita ng Iyong Ahensya + Kita ng Bawat Tier ng Sub-Ahensya',
    aTotal: 'A Total Valid Income = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (20% rate ng komisyon)',
    bTotal: 'B Total Valid Income = B + D + E = 20M + 20M + 30M = 70M (16% rate ng komisyon)',
    cTotal: 'C Total Valid Income = C + F = 70M + 80M =150M (20% rate ng komisyon)',
    dTotal: 'D Total Valid Income =20M (12% rate ng komisyon)',
    eTotal: 'E Total Valid Income =30M (12% rate ng komisyon)',
    fTotal: 'F Total Valid Income =80M (16% rate ng komisyon)',
    subagencyCommission: 'Komisyon ng Sub-ahensya = (Rate ng komisyon ng pangunahing ahensya - Rate ng komisyon ng sub-ahensya) × Kabuuang Balidong Kita ng sub-ahensya',
    agencyAC: 'Ahensya {A}\'s komisyon mula sa Ahensya {B}',
    thereforeAgency: 'Samakatuwid, kabuuang komisyon ng Ahensya {A} mula sa mga sub-ahensya',
    sinceAgency: 'Dahil ang Agency D, E, at F ay walang mga sub-ahensya, hindi sila maaaring kumita ng mga komisyon mula sa sub-ahensya.',
    seniorPolicy: 'Patakaran sa Senior',
    nomore: 'Wala nang Datos',
    active: 'Aktibo',
    disabled: 'Hindi Pinagana',
    deleted: 'Tinanggal',
    lastLogintime: 'Huling Oras ng Pag-login',
    onmic: 'Nasa Mic Ngayon'
  },
  sellerCoin: {
    detailsOf: 'Mga Detalye ng Pag-withdraw',
    fundsSent: 'Ipinaalam ang Pondo',
    transfer: 'Paglilipat',
    totalIncome: 'Kabuuang Kita',
    orderIncome: 'Kita sa Order',
    estimatedReward: 'Inaasahang Gantimpala',
    amount: 'Halaga',
    applicantId: 'ID ng Applicant',
    applicantName: 'Pangalan ng Applicant',
    orderId: 'Order ID',
    uploadScreenshot: 'I-upload ang Screenshot',
    ensureWithdrawal: 'Siguraduhing matagumpay ang pag-withdraw, pagkatapos ay i-upload ang screenshot at i-click ang butones sa ibaba upang ipaalam sa aplikante.',
    remain: 'Natitira',
    pleasePay: 'Bayaran agad at i-upload ang resibo. Kung lalampas sa oras, ang kwalipikasyon sa pagbabayad ng order ay makansela.',
    youCan: 'Maaari kang makakuha ng hanggang 5,000 puntos ng imbitasyon bawat araw',
    pleaseComplete: 'Mangyaring kumpletuhin ang pag-withdraw sa oras ',
    unableTo: 'Hindi makabayad, Tanggihan',
    notifyThe: 'Ipagbigay-alam ang aplikante',
    youCanGet: 'Maaari kang makakuha ng 1%-3% na sobrang bonus kung haharapin mo ang mga order nang napapanahon.',
    ifYou: 'Kung haharapin mo ang mga order sa loob ng 30 minuto maaari kang makakuha ng 3% na bonus.',
    egThe: 'Hal: Ang order na nagkakahalaga ng 90000 points, haharapin mo ito sa loob ng 30 minuto, maaari kang makakuha ng 3% na bonus, na 90000 × 3% = 2700 points.',
    gotIt: 'Nakuha na',
    pleaseUpload: 'Mangyaring mag-upload ng larawan',
    detail: 'Detalye',
    balance: 'Balance',
    exchange: 'Palitan',
    all: 'Lahat',
    recharge: 'Mag-recharge',
    official: 'Opisyal',
    exchangeDetail: 'Detalye ng Palitan',
    coinSeller: 'Nagbebenta ng Coin',
    levelUp: 'Taas ang Antas',
    currentLevel: 'Current level',
    myBalance: 'Aking Balanse',
    details: 'Mga Detalye',
    paymentMethod: 'Paraan ng Pagbabayad',
    myOrder: 'Aking Order',
    paymentMenthod: 'Paraan ng Pagbabayad',
    acceptingOrders: 'Tumanggap ng Mga Order',
    unavailable: 'Hindi Available',
    greetingMessage: 'Mga Setting ng Mensahe ng Pagbati',
    serviceUnavailable: 'Serbisyo Hindi Available',
    thisFeature: 'Ang feature na ito ay pansamantalang naka-lock. Mangyaring makipag-ugnayan sa suporta ng customer para sa tulong.',
    editMessage: 'I-edit ang Mensahe',
    customizeYour: 'I-customize ang iyong greeting message. Maaari kang magsama ng kapaki-pakinabang na impormasyon tungkol sa pagre-recharge ng mga barya.',
    theMessage: 'Ang Mensahe ay awtomatikong ipapadala kapag ang isang bagong user ay nagsimula ng pribadong chat sa iyo',
    save: 'I-save',
    pleaseEnterMessge: 'Mangyaring Ilagay ang iyong greeting message',
    salesMethod: 'Paraan ng Pagbebenta',
    user: 'User',
    coinseller: 'Coinseller',
    userId: 'User ID',
    check: 'Check',
    coinAmount: 'Halaga ng Barya',
    pleaseEnter: 'Mangyaring ilagay ang isang multiple ng 1',
    enterAt: 'Ilagay ng hindi bababa sa 100, sa multiples ng 1',
    transferDetails: 'Mga Detalye ng Paglilipat',
    recommendSeller: 'Irekomenda ang Nagbebenta',
    recent30Day: 'Kamakailang 30-Araw na Benta ng Barya',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry: 'Ang iyong bansa ay kasalukuyang walang magagamit na coin sellers.',
    pleaseContact: 'Mangyaring makipag-ugnayan sa suporta ng customer.',
    customerSupport: 'suporta ng customer',
    contact: 'Makipag-ugnayan',
    customRecharge: 'Pasadyang Recharge',
    rechargeDetails: 'Mga Detalye ng Recharge',
    myPoints: 'Aking Mga Puntos',
    todayRemaining: 'Natitirang quota ngayon',
    customExchange: 'Pasadyang Palitan',
    exchangeDetails: 'Mga Detalye ng Palitan',
    rechargeRules: 'Mga Panuntunan sa Recharge',
    sellerLevel: 'Antas ng Nagbebenta',
    proportion: 'Proporsyon',
    levelRequirement: 'Pangangailangan sa Antas',
    beginner: 'Nagsisimula',
    singleRecharge: 'Single recharge',
    standard: 'Pamantayan',
    senior: 'Senior',
    exchangeRules: 'Mga Panuntunan sa Palitan',
    note: 'Note',
    seniorCoin: 'Senior Coin Seller ay nakakakuha ng {point} puntos nang libre araw-araw. Extra sa ',
    beginnerSeller: 'Nagsisimulang Nagbebenta',
    standardSeller: 'Pamantayang Nagbebenta',
    seniorSeller: 'Senior na Nagbebenta',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'Mangyaring ilagay ang halaga ng recharge, multiples ng 100K',
    confirmation: 'Kumpirmasyon',
    userName: 'Pangalan ng User',
    theUser: 'Ang user ay na-blacklist',
    enterAmount: 'Ilagay ang halaga',
    pleaseInput3: 'Mangyaring ilagay ang halaga',
    theAmount: 'Ang halaga ay dapat na multiple ng 100000',
    pleaseInput4: 'Mangyaring ilagay o piliin ang halaga',
    pleaseSelect: 'Mangyaring piliin ang paraan ng pagbebenta',
    pleaseInput5: 'Mangyaring ilagay ang userId',
    atLeast: 'Hindi bababa sa 100K coins ang ililipat~',
    pleaseSelect2: 'Mangyaring piliin ang paraan ng pagbabayad',
    minimum: 'minimum',
    theAmount3: 'Ang halaga ay dapat na multiple ng 1',
    lessThan: 'mas mababa sa o katumbas ng 100000',
    orders: 'Mga Order',
    applicant: 'Applicant',
    method: 'Paraan',
    withdrawTime: 'Oras ng Pag-withdraw',
    viewDetail: 'Tingnan ang Detalye',
    toBe: 'Upang kumpirmahin',
    toBePaid: 'Upang bayaran',
    toBeCompleted: 'Upang makumpleto',
    completed: 'Nakumpleto',
    abnormal: 'Hindi normal',
    refused: 'Refused',
    confirmationTimeout: 'Kumpirmasyon timeout',
    paymentTimeout: 'Pagbabayad timeout',
    binance: 'Binance',
    scanThe: 'I-scan ang QR code para magbayad',
    quantity: 'Dami',
    orderAmount: 'Halaga ng Order',
    date: 'Petsa',
    payNow: 'Magbayad Ngayon',
    payment: 'Pagbabayad',
    pleasePay2: 'Mangyaring bayaran sa sumusunod na paraan',
    chainName: 'Pangalan ng Chain',
    contractAddress: 'Address ng Kontrata',
    theAbove: 'Ang address sa itaas ay may-bisa para sa recharge na ito lamang',
    copy: 'Copy',
    notice: 'Paunawa',
    pleaseTransfer: 'Mangyaring maglipat ng Extra 1 USDT upang masakop ang bayad sa Binance. Ang hindi paggawa nito ay maaaring antalahin ang iyong coin recharge.',
    paymentsMust: 'Ang mga pagbabayad ay dapat makumpleto sa loob ng 0.5 oras, o ang platform ay hindi mananagot para sa anumang mga isyu.',
    add: 'Idagdag',
    confirmTo: 'Kumpirmahin na tanggalin ang paraan ng Pagbabayad na ito',
    countryCurrency: 'Bansa at Uri ng Pera',
    selectPayment: 'Piliin ang paraan ng Pagbabayad na maaari mong ipadala',
    coinsSeller: 'Mga Panuntunan ng Coins Seller',
    standrd: 'Pamantayan',
    salesMethods: 'Mga Paraan ng Pagbebenta',
    coinsellerRules: 'Mga Panuntunan ng CoinSeller',
    whenApplying: 'Kapag nag-aaplay para sa isang pag-upgrade sa katayuan ng isang coin seller, walang mga kinakailangan sa deposito kailangan lamang ng 1-time na recharge para i-upgrade ang antas ng coin seller. Kung pipiliin mong magbitiw sa iyong posisyon bilang isang coin seller, ang iyong kasalukuyang papel na coin seller ay mag-e-expire',
    youCanReplenish: 'Maaari mong replenish ang iyong account nang direkta sa USDT, Epay o sa pamamagitan ng isa pang coin seller',
    fraudulentActivities: 'Ang mga fraudulent na gawain ay mahigpit na ipinagbabawal sa loob ng platform ng Hala.',
    anyViolations: 'Anumang paglabag ay magreresulta sa pagwawakas ng account ng coin seller',
    allRights: 'Lahat ng karapatan ay nakalaan sa Hala.',
    transferDetail: 'Detalye ng Paglilipat'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: 'Paanyaya',
    tasks: 'Mga Gawain',
    other: 'Iba pa',
    consume: 'Gumamit',
    giftIncome: 'Gift Income',
    received: 'Natanggap',
    from: 'mula sa',
    luckyGift: 'Masuwerteng regalo',
    hostCenter: 'Host Center',
    noAgent: 'Walang ahente',
    last7: 'Huling 7 araw',
    hourlyIncome: 'Oras-oras na kita',
    toReach: 'to reach',
    rules: 'Mga Panuntunan',
    pointsOverview: 'Pangkalahatang-ideya ng Mga Puntos',
    totalIncome: 'Total Income',
    gifts: 'mga regalo',
    workDetail: 'Detalye ng Trabaho',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: 'Live record ngayon',
    dailyStatistics: 'Araw-araw na Estadistika',
    startTime: 'Oras ng pagsisimula',
    endTime: 'Oras ng pagtatapos',
    duration: 'Tagal',
    points: 'Mga puntos',
    date: 'Date',
    giftPoints: 'Mga puntos ng regalo',
    removeBinding: 'Alisin ang Pagbubuklod',
    thisAction2: 'Ang aksyon na ito ay magbubuklod sa iyo mula sa {agentName}. Mangyaring kumpirmahin kung nais mong magpatuloy sa pagbubuklod'
  },
  bombRule: {
    afterThe: 'Matapos maabot ng halaga ng pagsabog sa silid ang tiyak na halaga, ang gift bomb ay lilitaw sa silid',
    oneCoins: '1 coins na natanggap sa silid = 1 halaga ng pagsabog',
    itWill: 'Ito ay awtomatikong sasabog pagkatapos matugunan ang mga kinakailangan, at ang may-ari ng silid ay makakatanggap ng kaukulang gintong barya na gantimpala'
  },
  descriptionLevel: {
    wealth: 'Kayamanan',
    charm: 'Alindog',
    wealthValue: 'Halaga ng Kayamanan',
    charmValue: 'Halaga ng Alindog',
    needTo: 'Kailangan',
    send: 'ipadala',
    receive: 'tumanggap',
    forThe: 'para sa pag-upgrade',
    theRich: 'Ang antas ng Rich ay binibilang ng mga barya na iyong ni-recharge',
    theCharm: 'Ang antas ng Charm ay kinakalkula batay sa bilang ng mga barya na iyong natatanggap',
    LevelLabel: 'Label ng Antas',
    level: 'Level',
    levelLogo: 'Logo ng Antas'
  },
  gameRank: {
    gameRank: 'Ranggo ng Laro',
    rules: 'Rules',
    thisWeek: 'Ngayong Linggo',
    lastWeek: 'Nakaraang Linggo',
    agentGaming: 'Ranggo ng Kita sa Agent Gaming',
    rankingRewards: 'Mga Gantimpala sa Ranggo',
    rankingIs: 'Ang ranggo ay batay sa kabuuang paglilipat ng pagsusugal ng mga user sa silid ng ahente at mga sub-room nito.',
    hostRoom: 'Ranggo ng Kita sa Host room',
    rankingIs2: 'Ang ranggo ay batay sa kabuuang kita sa paglalaro na nabuo sa silid ng host',
    notes: 'Mga Tala',
    eventDuration: 'Tagal ng kaganapan: Bawat kalendaryong linggo. Ang mga gantimpala ay ipinamamahagi lamang kung',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'Ipinagkakatiwala ng Hala ang karapatan sa panghuling interpretasyon ng kaganapang ito',
    rewardsDetail: 'Mga Detalye ng Gantimpala',
    decorationsPreview: 'Preview ng Mga Dekorasyon'
  },
  gameLegacyHall: {
    surpriseLucky: 'Surprise Lucky Bag',
    dailyPlayers: 'Ang mga pang-araw-araw na manlalaro ay maaaring magbukas ng isang Lucky bag sa susunod na araw para sa mga random na barya',
    eventRule: 'Panuntunan sa Kaganapan',
    usersSpending: 'Ang paggastos ng mga user sa mga laro ng kaganapan ay mabibilang sa kanilang iskor sa ranggo',
    thePlatform: 'Ang platform ay iikot ng mga laro ng kaganapan bawat 4 na oras, na may 4 na magkakaibang mga laro na itinatampok sa bawat pag-ikot',
    theTop: 'Ang nangungunang 3 pang-araw-araw na manlalaro ay makakatanggap ng mga frame at gantimpala sa barya',
    theTop2: 'Ang nangungunang 10 lingguhang manlalaro ay makakatanggap ng mga frame at gantimpala sa barya',
    usersWho: 'Ang mga user na lumahok sa mga laro ng kaganapan araw-araw ay maaaring magbukas ng isang lucky bag sa susunod na araw upang makatanggap ng random na halaga ng mga barya. Ang mas marami mong gastusin sa mga laro ng kaganapan, ang mas maraming barya na maaari mong makuha',
    behindPrevious: 'Sa likod ng nakaraan',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'Countdown:',
    days: 'araw',
    winOver: 'Manalo ng higit sa',
    coinsfrom: 'mga barya mula sa mga laro sa isang solong araw',
    earnOver: 'Kumita ng higit sa',
    coinsWitdh: 'na may rate ng return hanggang',
    fromOneDay: 'mula sa isang araw sa',
    game: 'Laro',
    fromA: 'mula sa isang solong pusta sa',
    inthisWeek: 'Sa Linggong ito',
    earnUp: 'Kumita ng hanggang sa',
    inAsingle: 'sa isang solong araw',
    eventRules: 'Mga Panuntunan sa Kaganapan',
    participateIn: 'Makilahok sa laro upang i-claim ang isang mas malaking lucky bag bukas',
    youDid: 'Hindi mo natanggap ang gantimpala sa barya. Makilahok sa laro at maaari kang magpatuloy na i-claim ang lucky bag bukas',
    participateIn2: 'Makilahok sa laro at maaari kang magpatuloy na i-claim ang lucky bag bukas',
    topDaily: 'Nangungunang Pang-araw-araw na Nagwagi ng Barya',
    topPayout: 'Nangungunang Nagwagi sa Rate ng Payout',
    topCoins: 'Nangungunang Nagwagi ng Barya Sa Isang Round Lingguhan',
    topPayout2: 'Nangungunang Nagwagi sa Rate ng Payout Sa Isang Round Lingguhan',
    topWeekly: 'Nangungunang Lingguhang Nagwagi ng Barya',
    historicalTop: 'Makasaysayang Nangungunang Nagwagi ng Barya Sa Isang Araw',
    historicalTop2: 'Makasaysayang Nangungunang Nagwagi sa Rate ng Payout Sa Isang Araw',
    historicalTop3: 'Makasaysayang Nangungunang Nagwagi ng Barya Sa Isang Round',
    historicalTop4: 'Makasaysayang Nangungunang Nagwagi sa Rate ng Payout Sa Isang Round',
    historicalTop5: 'Makasaysayang Nangungunang Nagwagi ng Barya Sa Isang Linggo',
    gameReward: 'Gantimpala sa Laro',
    usersSpending2: 'Ang paggastos ng mga user sa mga laro ng kaganapan ay mabibilang sa kanilang iskor sa ranggo',
    theTop3: 'Ang nangungunang 3 pang-araw-araw na manlalaro ay makakatanggap ng mga frame at gantimpala sa barya',
    theTop4: 'Ang nangungunang 10 lingguhang manlalaro ay makakatanggap ng mga frame at gantimpala sa barya',
    usersWho2: 'Ang mga user na lumahok sa mga laro ng kaganapan araw-araw ay maaaring magbukas ng isang lucky bag sa susunod na araw upang makatanggap ng random na halaga ng mga barya. Ang mas marami mong gastusin sa mga laro ng kaganapan, ang mas maraming barya na maaari mong makuha',
    coins: 'mga barya',
    flameRider: 'Flame Rider',
    sportCar: 'Sport Car',
    captainMeow: 'Captain Meow',
    profileFrame: 'Frame ng Profile'
  },
  gold: {
    coinsDetail: 'Mga Detalye ng Barya',
    coinBalance: 'Balanse ng Barya',
    all: 'ALL',
    sendGifts: 'Magpadala ng Mga Regalo',
    purchaseItems: 'Mga Item na Binili',
    games: 'Mga Laro',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'Mga Gantimpala sa Aktibidad',
  },
  integral: {
    all: 'All',
    cashOut: 'Mag-cash out',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: 'Oras ng Pag-withdraw',
    pointsAmount: 'Halaga ng Mga Puntos',
    depositAmount: 'Halaga ng Deposito',
    coinsAmount: 'Halaga ng Barya',
    transferTo: 'Ilipat sa',
    normal: 'Normal',
    pending: 'Nakabinbin',
    success: 'Success',
    failed: 'Nabigo',
    points: 'Points',
    pointsBalance: 'Balanse ng Mga Puntos',
    frozenPoints: 'Mga Puntos na Na-freeze',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: 'Uri ng Pera',
    paymentMethod: 'Payment method',
    pointsAmount2: 'Halaga ng mga puntos para sa pag-cash out',
    enterA: 'Ilagay ang isang multiple ng 100,000 (minimum na 200,000)',
    enterA2: 'Ilagay ang isang multiple ng 100000',
    accountInformation: 'Impormasyon ng Account',
    withdraw: 'Mag-withdraw',
    amount: 'Amount',
    exchangeRate: 'Palitan ng rate',
    exchangePoints: 'Mga Puntos ng Palitan',
    enterUserId: 'Ilagay ang User ID',
    check: 'Check',
    fee: 'Bayad',
    theAgency: 'Ang Ahensya ay makakatanggap',
    transferFee: 'Bayad sa paglilipat: 2%. Minimum na paglilipat ≥ 100,000 puntos.',
    clickTransfer: 'I-click ang transfer button upang ilipat ang kaukulang puntos sa iyong mga ahente',
    afterThe2: 'Matapos makumpleto ang paglilipat, hindi na ito maaaring kanselahin o bawiin',
    transferPoints: 'Mga Puntos ng Paglilipat',
    recommendedMethod: 'Inirerekomendang Paraan',
    lowerFees: 'Mas mababang bayad at nirerepaso sa loob ng 24 oras',
    paymentPassword: 'Hindi nakatakda ang password sa pagbabayad',
    cashOut2: 'Ang Cash out at Exchanges ay nangangailangan ng pagpapatunay ng password sa pagbabayad. Mangyaring i-set up muna ang iyong payment password.',
    cancel: 'Cancel',
    goTo: 'Pumunta sa Mga Setting',
    youHave: 'Naabot mo na ang 5 na hindi matagumpay na pagtatangka. Ang isa pang hindi matagumpay na pagtatangka ay magreresulta sa pag-freeze ng iyong account. Kung nakalimutan mo ang iyong password, mangyaring i-reset ito.',
    inputIncorrect: 'Maraming beses na maling pag-input ng password. Na-freeze ang iyong account, mangyaring subukan muli pagkatapos',
    verify: 'i-verify',
    gotIt: 'Got it',
    pointsInfo: 'Impormasyon ng Mga Puntos',
    whenA: 'Kapag ang isang user ay nagpadala sa iyo ng mga regalo gamit ang Mga Barya na ni-recharge sa pamamagitan ng Google, ang mga puntos na iyong natatanggap ay i-freeze sa loob ng 7 araw bago maging available. Kung hilingin ng user ang refund, ang mga puntos na iyon ay ibabawas. Mangyaring sundin ang mga panuntunan ng platform at iwasan ang anumang mga paglabag.',
    frozenPointsAre: 'Ang mga Frozen Points ay kasama sa kabuuang Balanse ng Mga Puntos',
    theUser2: 'Ang user ay na-blacklist',
    successfulWithdrawal: 'Matagumpay na Pag-withdraw',
    withdrawalAmount: 'Halaga ng Pag-withdraw',
    theFunds: 'Ang pondo ay darating sa loob ng 24 oras',
    pleaseEnter2: 'Mangyaring ilagay ang password',
    passwordIncorrect: 'Mali ang password',
    theAmount4: 'Ang halaga ay dapat na multiple ng 100000',
    pleaseEnter3: 'Mangyaring ilagay ang User ID',
    pleaseEnter4: 'Mangyaring ilagay ang tamang User ID',
    pleaseEnter5: 'Mangyaring ilagay ang halaga',
    minimumTransfer: 'Minimum na paglilipat ≥ 100,000 puntos',
    pleaseSelect3: 'Mangyaring piliin ang paraan',
    minimum: 'minimum',
    theAmount5: 'Ang halaga ay dapat na mas mababa sa',
    illegalInput: 'Iligal na input',
    pleaseEnter6: 'Mangyaring ilagay ang impormasyon ng Account'
  },
  invite: {
    inviteGame: 'Mag-anyaya ng Game User',
    currentRebate: 'Kasalukuyang Rebate',
    need: 'kailangan',
    toProgress: 'upang magpatuloy sa susunod na antas',
    gameReward: 'Game Reward',
    referralData: 'Data ng Referral',
    referralList: 'Listahan ng Referral',
    date: 'Date',
    gameBets: 'Mga Pusta sa Laro',
    inviteRewards: 'Mga Gantimpala sa Pag-anyaya',
    viewMore: 'Tingnan ang Higit Pa',
    inviteFriends: 'Mag-anyaya ng Mga Kaibigan',
    myReward: 'Aking Gantimpala',
    totalRewards: 'Kabuuang Mga Gantimpala',
    dailyReward: 'Araw-araw na Gantimpala',
    inviteRules: 'Mga Panuntunan sa Pag-anyaya',
    yourRebate: 'Ang iyong Rebate Rate ay nakasalalay sa iyong Kabuuang Mga Wastong Pusta sa huling 30 araw',
    totalValid2: 'Kabuuang Mga Wastong Pusta = Ang iyong sariling mga pusta + Ang sariling mga pusta ng bawat tier ng iyong mga inanyayang user',
    rebateFrom: 'Rebate mula sa Tier-1 na inanyayang user = Ang kanilang sariling mga pusta × Ang iyong rebate rate',
    rebateFrom2: 'Rebate mula sa Tier-2 na inanyayang user = Ang kanilang sariling mga pusta × (Ang iyong rebate rate - Tier-1 rebate rate)',
    ifThe: 'Kung ang Tier-2 na inanyayang user ay nag-anyaya ng Tier-3 user, maaari nitong taasan ang kanyang Kabuuang Mga Wastong Pusta, ngunit hindi siya makakakuha ng rebate mula sa Tier-3.',
    example: 'Halimbawa',
    tier1: 'Tier-1 na inanyayahan - Paano makalkula ang rebate mula sa mga direktang inanyayahan mo?',
    asRebate: 'Ang Rebate ni A mula kay B, C at D = (Mga Self Bets ni B + Mga Self Bets ni C + Mga Self Bets ni D) × Rebate Rate ni A =',
    bsRebate: 'Ang Rebate ni B mula kay E at F = (Mga Self Bets ni E + Mga Self Bets ni F) × Rebate Rate ni B =',
    csRebate: 'Ang Rebate ni C mula kay G = Mga Self Bets ni G × Rebate Rate ni C =',
    tier2: 'Tier-2 na inanyayahan - Paano makalkula ang rebate mula sa mga hindi direktang inanyayahan mo?',
    asRebate2: 'Ang Rebate ni A mula kay E at F = (Rebate Rate ni A - Rebate Rate ni B) × (Mga Self Bets ni E + Mga Self Bets ni F) =',
    asRebate3: 'Ang Rebate ni A mula kay G = (Rebate Rate ni A - Rebate Rate ni C) × Mga Self Bets ni G =',
    myInvitation: 'Aking Paanyaya',
    search: 'Search',
    invitationTime: 'Oras ng Paanyaya',
    inviteHost: 'Invite Host',
    inviteA: 'Mag-anyaya ng isang Host, Bawat isa hanggang sa',
    todayRewards: 'Mga Gantimpala Ngayon',
    rewardDetail: 'Detalye ng Gantimpala',
    creatorRewards: 'Wallet ng Mga Gantimpala ng Creator',
    collect: 'Kolektahin',
    invitationDate: 'Petsa ng Paanyaya',
    hostPolicy: 'Patakaran ng Host',
    halaReserves2: 'Ipinagkakatiwala ng Hala ang karapatan sa panghuling interpretasyon ng mga patakarang nakalista sa itaas.',
  },
  listContribution: {
    contributiont: 'Kontribusyon',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: 'Kahapon',
    game: 'Game',
    gift: 'Regalo',
    hostEarnings: 'Kita ng Host'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'Ipinagkakatiwala ng Hala ang karapatan sa panghuling interpretasyon ng mga patakarang nakalista sa itaas'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'Lumipat ng account',
    countryRegion: 'Bansa/Rehiyon',
    officialAgency: 'Opisyal na Ahensya ng Recharge',
    ttOff: '20% off',
    totalAmount: 'Kabuuang Halaga',
    purchase: 'Bilhin',
    pleaseComfirm: 'mangyaring kumpirmahin ang User ID',
    pleaseInput8: 'Mangyaring ilagay ang User ID',
    onlineService: 'Online na Serbisyo',
    dealOf: 'Deal ng huling 30 araw',
    recent30Day2: 'Kamakailang 30-Araw na Benta ng Barya',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'Ang iyong bansa ay kasalukuyang walang magagamit na coin sellers',
    pleaseContact2: 'Mangyaring makipag-ugnayan sa suporta ng customer.',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'Ang pag-unlad ng treasure chest ay nadadagdagan sa pamamagitan ng pagbibigay ng mga regalo sa silid',
    whenThe: 'Kapag ang progress bar ng chest key ay napuno, ang treasure chest ay bubuksan',
    afterThe3: '.Matapos matugunan ng level 3 at level 4 na treasure chests ang mga kinakailangan, i-lock ang mga ito sa loob ng 1 minuto at awtomatikong bubuksan',
    everyoneIn: 'Lahat ng tao sa kwarto ay may pagkakataong makuha ang mga reward sa treasure chest',
    onceThe: 'Kapag nabuksan na ang treasure chest, maaaring tumagal ng ilang minuto para maibigay ng system ang reward sa iyong account. Ang mga gintong barya ay idaragdag sa iyong balanse at ang kasuutan ay idaragdag sa iyong imbentaryo',
    theHigher: 'Kung mas mataas ang antas ng kaban ng kayamanan, mas malaki ang mga gantimpala sa loob nito',
    ifYou2: 'Kung pipiliin ka bilang isang VIP na may mas mababang antas ng VIP kaysa sa iyong kasalukuyang antas, hindi magkakabisa ang antas ng VIP',
    theProgress: 'Ire-reset ang progress bar ng chest key sa 00:00 (UTC+5:30) araw-araw'
  },
  share: {
    joinHala: 'Sumali sa Hala para mag-unlock ng maraming pagkakataong kumita at masiyahan sa mga iniangkop na benepisyo at reward para sa Mga Ahensya.',
    downloadTo: 'I-download para Maging Kasosyo',
    joinHala2: 'Sumali sa Hala para sa mga nakakatuwang laro at pagkakataong manalo ng mga kamangha-manghang premyo.',
    downloadAnd: 'I-download at Simulan ang Panalo',
    joinHala3: 'Sumali sa Hala at simulan ang iyong paglalakbay sa pagho-host. Makakuha ng mga pang-araw-araw na bonus hanggang $36!',
    inviteYou: 'Anyayahan kang sumali sa Ahensya',
    downloadNow: 'I-download Ngayon para Simulan ang Pagho-host',
    comeWith: 'Sumama ka sa akin na sumali sa chat room sa Hala',
    enthusiastsFrom: 'ang mga mahilig sa buong mundo ay nagsasama-sama upang ibahagi...',
    igniteEndless: 'Magsiklab ng walang katapusang libangan',
    download: 'I-download',
    halaLive: 'Hala Live',
    showMe: 'Ipakita sa Akin na Masaya ang Mundo',
    saySomething: 'Sabihin mo...',
    downloadHala: 'I-download ang Hala App'
  },
  starHost: {
    starHost: 'Star Host',
    level2: 'Ang antas {level} ay pinananatili sa loob ng  {days} mga araw',
    currentSalary: 'Kasalukuyang suweldo',
    points: 'Points',
    likes: 'Mga gusto',
    stillNeed: 'Still need',
    done: 'Tapos na',
    numberOf2: 'Bilang ng mga Gifters',
    gifters: 'Mga nagregalo',
    gcoinGifts: 'Mga Regalo ng Gcoin',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: 'min',
    completeAll: 'Kumpletuhin ang lahat ng sumusunod na gawain upang mag-upgrade',
    follower: 'Tagasunod',
    numberOf3: 'Bilang ng mga Gifters',
    daysAt: 'Mga araw sa {level} Level',
    giftCollection: 'Koleksyon ng Regalo',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: 'Inaasahang suweldo',
    gcoin: 'Gcoin',
    status: 'Katayuan',
    levelReached: ' Naabot ang Antas',
    notAchieved: 'Hindi Nakamit',
    starHost2: 'Mga panuntunan ng star host',
    eachStar: 'Ang bawat Star Host ay may 3 araw na panahon ng pagsubok',
    theyWill: 'Magiging opisyal lang sila ng Star Host kung matutugunan nila ang mga pamantayan sa A-level sa lahat ng 3 araw',
    thoseWho: 'Ang mga hindi maabot ang pang-araw-araw na A-level na mga target ay tatanggalin',
    firedHosts: 'Ang mga natanggal na host ay hindi makakakuha ng base na suweldo ng Star Host',
    starHost3: 'Ang batayang suweldo ng Star Host ay binabayaran linggu-linggo, tuwing Lunes',
    ifA: 'Kung ang isang Star Host ay hindi nakumpleto ang mga pang-araw-araw na gawain, makakatanggap lamang sila ng 50% ng oras-oras na suweldo',
    selfGifting: 'Ang pagbibigay ng sarili ay mahigpit na ipinagbabawal para sa lahat ng mga target na regalo',
    starHost4: 'Mga Gantimpala ng Star Host ng Iba\'t ibang Antas',
    level: 'Level',
    dailyExtra: 'Mga Gantimpala sa Pang-araw-araw na Dagdag na Puntos',
    liveBroadcast: 'Kinakailangan ang oras ng live na broadcast',
    starHost5: 'Kinakailangan ng Star Host para sa iba\'t ibang antas',
    requirements: '(mga) kinakailangan',
    yourApplication: 'Ang iyong aplikasyon ay inaprubahan ng opisyal',
    stayOn: 'Manatili sa A-level sa loob ng 7 araw',
    over1k: 'Mahigit 1k fans',
    totalGifter: 'Kabuuang numero ng gifter > 300',
    receiveAll: 'Tumanggap ng lahat ng "Maswerteng" regalo',
    everyLucky: 'Ang bawat numero ng masuwerteng regalo ay dapat na higit sa 100',
    stayOn2: 'Manatili sa S-Level sa loob ng 10 araw',
    over2k: 'Higit sa 2k fans',
    totalGifter2: 'Kabuuang numero ng regalo> 300',
    receiveAll2: 'Tumanggap ng lahat ng "Mainit" na regalo',
    stayOn3: 'Manatili sa SS-Level sa loob ng 10 araw',
    over5k: 'Higit sa 5k tagahanga',
    totalGifter3: 'Kabuuang numero ng gifter > 1000',
    receiveAll3: 'Tumanggap ng lahat ng "Luxury" na regalo',
    starHost6: 'Mga Pang-araw-araw na Gawain ng Star Host',
    dailyAssessment: '(Daily Assessment System): Pakikipag-ugnayan / Mga Regalo',
    gcionGifts: 'Mga Regalo ng Gcion',
    rulesTo: 'Mga panuntunan para pababain ang Star Host Level',
    failTo: 'Nabigong matugunan ang mga pamantayan ng kasalukuyang antas sa loob ng 3 magkakasunod na araw.',
    failingTo: 'Nabigong matugunan ang mga pamantayan <span>3 beses sa loob ng isang linggo',
    ifThe2: 'Kung ang host na hindi nakakatugon sa pang-araw-araw na kinakailangan ay A-level , siya ay direktang tatanggalin sa trabaho sa halip na i-degraded. Pagkatapos masira, dapat matugunan ng host ang mga pamantayan ng orihinal na antas sa loob ng 3 magkakasunod na araw upang mabawi ang antas',
    involvementIn: 'Paglahok sa malalaking paglabag o negatibong insidente.',
    causingDamage: 'Nagdudulot ng pinsala sa mga interes o brand image ng platform',
    applyFor: 'Mag-aplay para sa pagtigil nang mag-isa',
    liveStreaming: 'Mga Kinakailangan sa Live Streaming',
    liveStream: 'Ang nilalaman ng live stream ay dapat na nakaayon sa itinalagang uri ng host',
    roomHosts: 'Ang mga host ng silid ay ipinagbabawal na i-mute ang kanilang mikropono sa mahabang panahon habang nag-broadcast',
    liveStreams: 'Dapat isagawa ang mga live stream gamit ang 9-seat microphone room layout.',
    otherSeats: 'Ang iba pang mga upuan sa kuwarto ay hindi pinapayagang sakupin ng mga user o mga miyembro ng audience na nagmu-mute ng kanilang mga mikropono para sa gawaing pagsasaka.',
    discriminatoryInsulting: 'Mahigpit na ipinagbabawal sa silid ang mga diskriminasyon, nakakainsulto, o nakakasakit na pananalita'
  },
  starRoom: {
    afterCountdown: 'Pagkatapos ng countdown araw-araw, ang Top3 rooms ay ililista sa Star Room Rank',
    top20Star: 'Ang mga nangungunang 20 star na kuwarto ay gagantimpalaan bilang masaganang bonus pagkatapos ng linggong ito',
    countdown: 'Countdown：',
    top3Daily: 'Magiging kwalipikadong sumali sa lingguhang mga star room ang Top3 daily top3 room',
    starRooms: 'Iraranggo ang mga star room sa huling araw ng linggo. Iraranggo ito ayon sa kabuuang daloy ng mga barya ng bawat kuwarto',
    top20Weekly: 'Ang nangungunang 20 lingguhang may-ari ng star room ay makakakuha ng mga reward bilang sumusunod',
    qualificationTo: 'Kwalipikasyon para lumahok sa kaganapang ito: Ang anumang paglabag o ilegal na pag-uugali ay hindi pinapayagan sa kwarto, kapag nahanap na, hala ay madidisqualify ang kwarto at aalisin ito sa ranggo',
    theRewards: 'Ang mga reward ay ipapadala tuwing Lunes.',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'Mag-imbita ng mga Host',
    pointsMax: '5,000 puntos max araw-araw',
    firstRecharge: 'Unang-recharge na mga user',
    get20: 'Kumuha ng $20 nang Libre',
    oneInvite: '1.Imbitahan ang mga host na magsimula nang live, kapag natapos na ang mga host na inimbitahan mo.',
    aFinish: 'a. Tapusin ang pag-verify ng mukha sa task center',
    bCreate: 'b.Gumawa ng sariling silid',
    cLive: 'c. Live sa mic sa loob ng 3 oras sa kanyang silid',
    dClaim: 'd.I-claim ang mga live na reward sa unang pagkakataon',
    youGet: 'Makakakuha ka ng mga reward na puntos araw-araw mula sa iyong mga wastong numero ng mga inimbitahang host. Maaari mong i-claim ang mga reward sa susunod na araw.',
    validHost: 'Wastong host',
    pointsReward: 'Gantimpala ng mga Puntos',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: 'Aking mga inimbitahang host',
    validHosts: 'Mga Wastong Host Ngayon',
    pointsRewards: 'Mga Gantimpala ng Puntos',
    validHosts2: 'Mga Wastong Host Kahapon:',
    claim: 'Claim',
    claimed: 'Inangkin',
    completedTime: 'Nakumpletong Oras',
    ifYour: 'Kung natapos ng iyong mga kaibigan ang unang pag-recharge, makakakuha ka ng maraming reward. (Isasama rin ang offline na recharge).',
    theMore: 'Kapag mas marami ang naaabot ng unang halaga ng recharge, mas maraming mga barya ang mabibigyan mo ng gantimpala, at ito ay hanggang $20 araw-araw.',
    inviteesRecharge: 'Mga Inimbitahan Mag-recharge ng mga barya',
    yourReward: 'Ang Iyong Reward Coins',
    threeOnly: '3. Tanging ang mga user na inimbitahang mag-recharge sa loob ng 30 araw ang mabibilang bilang mga wastong user na first-recharge.',
    seniorAnd: 'Ang nakatatanda at karaniwang nagbebenta ay mabibilang lamang kapag sila ay nag-recharge mula sa app o opisyal nang direkta (pumunta sa iyong admin para sa mga paraan ng pagbabayad) sa unang pagkakataon ay mabibilang na mga valid na first-recharge na user.',
    myInvited2: 'Aking mga inimbitahang User',
    rechargeCoins: 'Mag-recharge ng mga barya',
    coinsRewards: 'Mga Gantimpala ng Barya',
    firstRecharge2: 'First-recharge na mga barya Kahapon:',
    firstRecharge3: 'Unang-recharge na mga barya',
    firstRecharge4: 'Oras ng Unang-recharge'
  },
  hostPolicy: {
    title: 'Patakaran ng Host',
    section1Title: 'Basic Salary sa Unang Linggo para sa Bagong Host',
    requirement: 'Kinakailanan',
    newHostsDesc: 'Mga bagong host na sumali sa Hala sa unang linggo',
    activeTime: 'Active Time sa Mic',
    oneHour: '1 Oras',
    twoHour: '2 Oras',
    threeHour: '3 Oras',
    baseSalary: 'Basic Salary (Points)',
    incomeRequirement: 'Kinakailanan ng Kita',
    none: 'Wala',
    remarks: 'Mga Tala',
    remarksDesc: 'Maximum 3 oras/araw. Maximum 7 araw. Kabuuang maximum reward na 35,000 points',
    note1: 'Mula sa petsa ng pagpaparehistro ng host, magsisimula ang countdown ng validity period ng 7-araw na basic salary.',
    note2: 'Ang mga host na gumagamit ng maraming account o nakalog-in gamit ang maraming IP o device ay makakaltas ng basic salary reward.',
    note3: 'Kung ang kita ng host sa nakaraang 7 araw ay higit sa 150,000 puntos, siya ay makakakuha ng Ordinary Host Hourly Reward sa halip na New Host Base Salary Reward.',
    section2Title: 'Parehong Reward para sa Ordinary Host',
    level: 'Antas',
    incomeRequirementShort: 'Kinakailanan ng Kita',
    hourlyReward: 'Hourly Reward',
    maximumDailyHours: 'Maximum na Daily na Oras',
    section2Note1: 'Ang 15 minuto nang tuloy-tuloy sa Mic ay ituturing na effective time.',
    section2Note2: 'Lahat ng rewards ay naka-settle sa puntos, at kailangang i-claim sa task system.',
    section2Note3: 'Ang platform rewards ay hindi mabibilang sa points requirement.',
    section2Note4: 'Ang mga puntos ay duduktan kapag nakadetect ang maraming IP o device.',
    section2Note5: 'Ang nakaraang 7 araw ay nangangahulugang nakaraang 6 araw+ngayon, kaya maaaring makakuha ka ng mas maraming hourly reward habang naabot mo ang mas mataas na points level nang maaga.',
    section2Note6: 'Ang L-level na non-target rewards ay valid lamang sa unang 7 araw pagkatapos ng pagpaparehistro. Pagkatapos ng 7 araw, ang mga host ay makakakuha ng 500 libreng puntos araw-araw nang permanente.',
    section3Title: 'Mga Regulasyon ng Host',
    regulation1: 'Ipinagbabawal sa mga host na magrehistro ng maraming account.',
    regulation2: 'Ipinagbabawal na i-promote ang mga third-party platform.',
    regulation3: 'Ang mga menor de edad ay ipinagbabawal nang husto.',
    regulation4: 'Ang isang host ay maaari lamang na magkaroon ng isang beripikadong ID. Lamang ang mga beripikadong ID ang maaaring magsimula ng live streaming at mag-withdraw ng kita.',
    regulation5: 'Kahit anong gawa ng pagpanggap ng pagpapatoto sa mukha upang magsimula ng live streaming o mag-withdraw ng kikita aypermanenteng ipagbawal.',
    regulation6: 'Ang pagbibigay ng ID sa iba para sa live streaming ay magreresulta sa permanenteng pagbabawal ng ID ng sistema.',
    regulation7: 'Sa voice room, ang mga host ay dapat aktibong batiin ang mga user na pumasok sa room.',
    regulation8: 'Ang larawan ng cover ng voice room ay dapat gumamit ng tunay at compliant na litrato ng host.',
    regulation9: 'Ang platform ng Hala ay striktong ipinagbabawal ang anumang pandaraya na aktibidad. Anumang paglabag ay magreresulta sa permanenteng suspensyon ng account.',
    footer: 'Ang Hala ay nagrereserba ng karapatan sa huling interpretasyon ng mga patakaran sa itaas.',
  },
  correspondingRevenue: 'natutugunan ang mga kinakailangan sa kita. Ang lahat ng mga gantimpala ay ipagkakaloob',
  within12: 'sa loob ng 1-2 araw ng trabaho pagkatapos matapos ang kaganapan'
}
